module.exports = __webpack_public_path__ + "img/core-bg4.e7f7d133.jpg";